import { isEmpty } from 'lodash'
import jwt_decode from 'jwt-decode'

export default {
  profile(state) {
    let profile = null
    if (isEmpty(state.accessToken)) {
      return profile
    }
    try {
      profile = jwt_decode(state.accessToken)
    } catch (e) {
      profile = null
    }
    return profile
  },

  getAuthTokens: state => {
    return state.auth_tokens
  },

  isRefreshing: state => {
    return state.isTokenRefreshing
  },

  refreshingCall: state => {
    return state.refreshingCall
  },

  isAccountActive: state => {
    return !isEmpty(state.profile) && !isEmpty(state.accountId)
  }
}



// WEBPACK FOOTER //
// ./src/store/app/getters.js